import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ClipLoader, PulseLoader} from "react-spinners";
import { FiTrash2 } from "react-icons/fi";
import { faClipboard, faList } from "@fortawesome/free-solid-svg-icons"


/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  `;



export default function Dimensi() {
  document.title = "Penilaian";

  // const [savingId, setSavingId] = useState(null);
  
  const [savingKey, setSavingKey] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem('ysb_school_id');
  const storageTeacher = localStorage.getItem('teacherID');
  const storageBranch = localStorage.getItem('ysb_branch_id');

  // SEARCH
  const [searchMap, setSearchMap] = useState({});

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);


  const [headerSchools, setHeaderSchools] = useState([]);
  const [activeSchoolId, setActiveSchoolId] = useState("");

  // Table data
  const [getData, setGetData] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [editingValues, setEditingValues] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");
  const [savingCells, setSavingCells] = useState({});

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    user_id:"",
  });


  const [updateId, setUpdateID] = useState(null);
  
  const [scorePicker, setScorePicker] = useState({
    open: false,
    recapId: null,
    top: 0,
    left: 0,
    meta: null,
  });
  const id_user = localStorage.getItem("id_admin") || "";
  const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));


  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      // const semesterRes = await APILA.get(
      //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
      //   { ...fetchParams, signal: controller.signal }
      // );

      const semesterRes = await APIMS.get(
        `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        { ...fetchParams, signal: controller.signal }
      );

      if (!isMounted.current) return;

      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [descending, fetchParams, keyword, limit, page]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);


  // =========================
  // Filter complete
  // =========================
  const isFilterComplete = isFilterDirty && !!form2.ysb_semester_id;

  const buildEditingMap = (rows) => {
    const nextMap = {};
    (rows || []).forEach((item) => {
      (item?.data_school || []).forEach((school) => {
        const key = `${item?.ysb_sub_element_id}__${school?.ysb_school_id}`;
        nextMap[key] = school?.ysb_sub_element_value ?? "";
      });
    });
    return nextMap;
  };

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
  if (!form2.ysb_semester_id) return;

  try {
    const response = await APILA.get(
      `/api/angket-employees?page=1&limit=1000&ascending=${ascending}&search=`,
      {
        params: {
          ysb_semester_id: form2?.ysb_semester_id,
        },
        ...fetchParams,
      }
    );

    if (response?.status === 200) {
      const headers = response?.data?.header || [];
      const rows = response?.data?.data || [];

      setHeaderSchools(headers);
      setGetData(rows);
      setEditingValues(buildEditingMap(rows));

      setActiveSchoolId((prevActiveSchoolId) => {
        const stillExists = headers.some(
          (item) => item?.ysb_school_id === prevActiveSchoolId
        );

        if (prevActiveSchoolId && stillExists) {
          return prevActiveSchoolId;
        }

        return headers?.[0]?.ysb_school_id || "";
      });
    }
  } catch (error) {
    // swal({
    //   title: "Gagal",
    //   text: error?.response?.data?.message || "Gagal mengambil data",
    //   icon: "error",
    // });
    console.log("silahkan buat List perilaku untuk semester ini")
  }
}, [form2?.ysb_semester_id, fetchParams, ascending]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);



  // FIRST LOAD
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id 
    ) return;
  
    firstLoadDone.current = true;
  
    (async () => {
      setIsFetching(true);
      await GetResponseData();
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  
  }, [
    form2.ysb_semester_id
  ]);

  // =========================
  // HANDLER perubahan filter 
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };


  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    if (!form2.ysb_semester_id  ) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);

    try {
      setActiveSchoolId("");
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const filteredData = useMemo(() => {
    if (!Array.isArray(getData)) return [];

    const keywordValue = searchKeyword.trim().toLowerCase();
    if (!keywordValue) return getData;

    return getData.filter((item) =>
      String(item?.description_anomaly || "").toLowerCase().includes(keywordValue)
    );
  }, [getData, searchKeyword]);


  useEffect(() => {
    if (headerSchools.length > 0 && !activeSchoolId) {
      setActiveSchoolId(headerSchools[0]?.ysb_school_id || "");
    }
  }, [headerSchools, activeSchoolId]);

  const activeSchoolHeader = useMemo(() => {
    return headerSchools.find((item) => item?.ysb_school_id === activeSchoolId) || null;
  }, [headerSchools, activeSchoolId]);


  const getCellKey = (subElementId, schoolId) => `${subElementId}__${schoolId}`;

  const getSchoolItem = (row, schoolId) => {
    return (row?.data_school || []).find((item) => item?.ysb_school_id === schoolId) || null;
  };

  // const handleNilaiChange = (subElementId, schoolId, value) => {
  //   const cellKey = getCellKey(subElementId, schoolId);
  //   setEditingValues((prev) => ({
  //     ...prev,
  //     [cellKey]: value,
  //   }));
  // };

  const handleNilaiChange = (subElementId, schoolId, value) => {
    // boleh kosong, supaya user tetap bisa hapus isi input
    if (value === "") {
      const cellKey = getCellKey(subElementId, schoolId);
      setEditingValues((prev) => ({
        ...prev,
        [cellKey]: "",
      }));
      return;
    }

    // blok minus / nilai kurang dari 0
    if (Number(value) < 0) return;

    const cellKey = getCellKey(subElementId, schoolId);
    setEditingValues((prev) => ({
      ...prev,
      [cellKey]: value,
    }));
  };

  const saveNilai = async (row, schoolItem) => {
    const cellKey = getCellKey(row?.ysb_sub_element_id, schoolItem?.ysb_school_id);
    const currentValue = editingValues[cellKey] ?? "";
    const originalValue = schoolItem?.ysb_sub_element_value ?? "";

    if (String(currentValue) === String(originalValue)) return;

    setSavingCells((prev) => ({ ...prev, [cellKey]: true }));

    const id = schoolItem?.ysb_angket_employee_id || "default";
    const payload = {
      ysb_semester_id: row?.ysb_semester_id,
      ysb_element_id: row?.ysb_element_id,
      ysb_sub_element_id: row?.ysb_sub_element_id,
      ysb_school_id: schoolItem?.ysb_school_id,
      ysb_branch_id: schoolItem?.ysb_branch_id,
      ysb_sub_element_value: currentValue === "" ? "" : Number(currentValue),
      user_id: output_id_user,
    };

    try {
      const response = await APILA.put(`/api/angket-employees/${id}`, payload, fetchParams);
      const returnedData = response?.data?.data || response?.data || {};

      setGetData((prev) =>
        prev.map((item) => {
          if (item?.ysb_sub_element_id !== row?.ysb_sub_element_id) return item;

          return {
            ...item,
            data_school: (item?.data_school || []).map((school) => {
              if (school?.ysb_school_id !== schoolItem?.ysb_school_id) return school;

              return {
                ...school,
                ysb_angket_employee_id:
                  returnedData?.ysb_angket_employee_id ||
                  returnedData?.id ||
                  (id === "default" ? school?.ysb_angket_employee_id : id),
                ysb_sub_element_value:
                  returnedData?.ysb_sub_element_value ??
                  (currentValue === "" ? "" : Number(currentValue)),
                nilai:
                  returnedData?.data_school?.find?.(
                    (item) => item?.ysb_school_id === schoolItem?.ysb_school_id
                  )?.nilai ??
                  returnedData?.nilai ??
                  school?.nilai,
                status:
                  returnedData?.data_school?.find?.(
                    (item) => item?.ysb_school_id === schoolItem?.ysb_school_id
                  )?.status ??
                  // returnedData?.status ??
                  school?.status,
              };
            }),
          };
        })
      );

      await GetResponseData();
    } catch (error) {
      setEditingValues((prev) => ({
        ...prev,
        [cellKey]: originalValue,
      }));

      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal menyimpan nilai",
        icon: "error",
      });
    } finally {
      setSavingCells((prev) => ({ ...prev, [cellKey]: false }));
    }
  };

  

  // SEARCH 
  useEffect(() => {
    setSearchMap({});
  }, [form2.ysb_semester_id, form2.ysb_dimensi_id]);


  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };


  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body">
       
     <div className="page-header-card">
             <div className="page-header-top d-flex">
               {isTabletOrMobile ? (
                 <>
                   <div className="page-title-wrap">
                     <span className="page-title-icon">
                       <FontAwesomeIcon icon={faClipboard} />
                     </span>
                     <h4 className="page-title-text"> Penilaian Karyawan</h4>
                   </div>
     
                   <div className="ml-auto">
                     <button
                       className="btn btn-create"
                       style={{
                         borderRadius: 12,
                         padding: "8px 14px",
                         boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                       }}
                     >
                       <Link to="/angket-employees/config-anomalys" style={{ textDecoration: "none", color: "#fff" }}>
                         <FontAwesomeIcon icon={faList} /> List Perilaku
                       </Link>
                     </button>
                   </div>
                 </>
               ) : (
                 <>
                   <div className="page-title-wrap">
                     <span className="page-title-icon">
                       <FontAwesomeIcon icon={faClipboard} />
                     </span>
                     <h4 className="page-title-text"> Penilaian Karyawan</h4>
                   </div>
     
                   <div className="ml-auto">
                     <button
                       className="btn btn-create"
                       style={{
                         borderRadius: 12,
                         padding: "8px 14px",
                         boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                       }}
                     >
                       <Link to="/angket-employees/config-anomalys" style={{ textDecoration: "none", color: "#fff" }}>
                         <FontAwesomeIcon icon={faList} /> List Perilaku
                       </Link>
                     </button>
                   </div>
                 </>
               )}
             </div>
           </div>


        <div className="body-content">
    
          {/* FILTER */}
           {isTabletOrMobile ? (
                    <div className="title-page">
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                          style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            background: "#fff",
                          }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>
                      </Row>
          
                      <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                        <button
                          onClick={handleCari}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: "#eca91aff",
                            color: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          Cari
                        </button>
                      </Row>
                    </div>
                  ) : (
                    <div className="mb-3">
                      {loading ? (
                        <div className="mb-3 d-flex">
                          <div className="shimmer shimmer-select mr-2" style={{ width: 180, borderRadius: "12px" }} />
                          <div className="shimmer shimmer-select mr-2" style={{ width: 60, borderRadius: "12px" }} />
                        </div>
                      ) : (
                        <div className="mb-3 mt-1">
                          <div className="d-flex">
                            <select
                              className="mr-2"
                              name="ysb_semester_id"
                              value={form2.ysb_semester_id}
                              onChange={handleChange}
                              style={{
                                border: "1px solid #d9defa",
                                borderRadius: "12px",
                                fontSize: "14px",
                                padding: "10px 12px",
                                background: "#fff",
                              }}
                            >
                              <option value="" hidden>
                                {namaTA} (Semester {namaSmstr})
                              </option>
                              {getDataSemesterMap.map((user, index) => (
                                <option key={index} value={user?.id}>
                                  {user?.name_year} (Semester {user?.semester})
                                </option>
                              ))}
                            </select>
          
                            <button
                              onClick={handleCari}
                              className="btn"
                              style={{
                                fontSize: "13px",
                                padding: "10px 16px",
                                borderRadius: "12px",
                                backgroundColor: "#eca91aff",
                                color: "#fff",
                                cursor: "pointer",
                              }}
                            >
                              Cari
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

          {/* LOADER */}
          {isFetching && (
            <div className="text-center" style={{ padding: "10px 0" }}>
              <span style={{color: "#2e52aeff", fontWeight: "500"}}><PulseLoader color={'#3f5bea'} size={12}/></span>
            </div>
          )}

          {/* TABLE */}
          {hasSearched && !isFetching && (
            <Col xl="12" sm="12">
              <div className="mt-3">
                <div className="body-table">
                  <div className="mt-3 mb-3">
                    <div className="at-search">
                      <input
                        className="at-input"
                        placeholder="Cari Perilaku"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                    </div>
                  </div>

                  {headerSchools.length > 0 ? (
                    <Tabs
                      id="tab-sekolah-penilaian-karyawan"
                      activeKey={activeSchoolId}
                      onSelect={(key) => setActiveSchoolId(key)}
                      className="mb-3 mt-3 nav-tabs"
                    >
                      {headerSchools.map((school, index) => {
                        const schoolId = school?.ysb_school_id || "";

                        return (
                          <Tab
                            key={`${schoolId}-${index}`}
                            eventKey={schoolId}
                            title={schoolId || "-"}
                            className="nav-item"
                          >
                            <div
                              className="table-scroll"
                              // style={{
                              //   overflowX: "auto",
                              //   WebkitOverflowScrolling: "touch",
                              //   border: "1px solid #dee2e6",
                              // }}
                              style={{borderRadius: "10px", border: "1px solid #3f5bea",}}
                            >
                              <table className="table table-bordered table-laporan-adab mb-0"
                              >
                                <thead style={{ backgroundColor: "#3f5bea", color: "white"}}>
                                  <tr>
                                    <th 
                                    rowSpan={2}
                                    style={{ textAlign: "center", 
                                      backgroundColor: "#3f5bea",
                                      color: "#fff",
                                      verticalAlign: "middle",
                                        textAlign: "center",
                                      border: "1px solid #e0e0e0ff" }}>No</th>
                                    <th
                                      rowSpan={2}
                                      style={{
                                        verticalAlign: "middle",
                                        textAlign: "center",
                                        border: "1px solid #fff",
                                        color: "#fff",
                                        minWidth: "280px",
                                        position: "sticky",
                                        left: 0,
                                        zIndex: 4,
                                        backgroundColor: "#3f5bea",
                                        boxShadow: "2px 0 8px rgba(0,0,0,0.08)",
                                      }}
                                    >
                                      Perilaku
                                    </th>

                                    <th
                                      colSpan={2}
                                      style={{
                                        textAlign: "center",
                                        border: "1px solid #fff",
                                        color: "#fff",
                                        minWidth: "100px",
                                        backgroundColor: "#3f5bea",
                                      }}
                                    >
                                      {schoolId || "-"}
                                    </th>
                                  </tr>

                                  <tr>
                                    <th
                                      style={{
                                        textAlign: "center",
                                        border: "1px solid #fff",
                                        color: "#fff",
                                        minWidth: "50px",
                                        backgroundColor: "#3f5bea",
                                      }}
                                    >
                                      Jumlah Keluhan
                                    </th>

                                    <th
                                      style={{
                                        textAlign: "center",
                                        border: "1px solid #fff",
                                        color: "#fff",
                                        minWidth: "50px",
                                        backgroundColor: "#3f5bea",
                                      }}
                                    >
                                      KKCA
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {filteredData.length > 0 ? (
                                    filteredData.map((row, rowIndex) => {
                                      const schoolItem = getSchoolItem(row, schoolId);
                                      const cellKey = getCellKey(row?.ysb_sub_element_id, schoolId);
                                      const inputValue = editingValues[cellKey] ?? "";
                                      const isSaving = !!savingCells[cellKey];

                                      return (
                                        <tr
                                          key={`${row?.ysb_sub_element_id || "row"}-${schoolId}-${rowIndex}`}
                                        >
                                          <td style={{ lineHeight: "2", textAlign: "center",
                                          verticalAlign: "middle",
                                          }}>{rowIndex + 1}</td>

                                          <td
                                            style={{
                                              verticalAlign: "middle",
                                              whiteSpace: "normal",
                                              position: "sticky",
                                              left: 0,
                                              zIndex: 2,
                                              backgroundColor: "#fff",
                                              minWidth: "280px",
                                              boxShadow: "2px 0 8px rgba(0,0,0,0.06)",
                                            }}
                                          >
                                            {row?.description_anomaly || "-"}
                                          </td>

                                          <td
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                            }}
                                          >
                                            {!isSaving ? (
                                            
                                              <input
            type="number"
            min="0"
            value={inputValue}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e" || e.key === "E") {
                e.preventDefault();
              }
            }}
            onChange={(e) =>
              handleNilaiChange(
                row?.ysb_sub_element_id,
                schoolId,
                e.target.value
              )
            }
            onBlur={() => {
              if (schoolItem) {
                saveNilai(row, schoolItem);
              }
            }}
            disabled={!schoolItem || isSaving}
            style={{
              width: "100%",
              minWidth: "90px",
              textAlign: "center",
              border: "1px solid #d9defa",
              borderRadius: "8px",
              padding: "6px 8px",
              backgroundColor:
                !schoolItem || isSaving ? "#f5f7ff" : "#fff",
            }}
          />
                                            ) : (
                                              <div style={{ marginTop: 6 }}>
                                                <PulseLoader color={"#3f5bea"} size={6} />
                                              </div>
                                            )}
                                          </td>

                                          <td
                                            style={{
                                              textAlign: "center",
                                              verticalAlign: "middle",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {schoolItem?.status || "-"}
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{
                                          textAlign: "center",
                                          padding: "16px",
                                        }}
                                      >
                                        Data tidak ditemukan
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Tab>
                        );
                      })}
                    </Tabs>
                  ) : (
                    <div style={{ textAlign: "center", padding: "16px" }}>
                      silahkan buat list perilaku untuk semester ini :)
                    </div>
                  )}
                </div>
              </div>
            </Col>
          )}
        </div>
      </div>

       


    </>
    
  );
}

